import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { axiosPrivate } from 'app/utils';
import type { GetRunStatsResponse } from '../types';

export const LUNAR_RUN_STATS_QUERY_KEY = 'lunar-run-stats';

async function fetchLunarRunStats(): Promise<GetRunStatsResponse> {
  const { data } = await axiosPrivate.get<GetRunStatsResponse>(
    '/v3/support/lunar-search/runs/stats'
  );
  return data;
}

// One request serves the sidebar count, the tab counts and the stat cards. A failure leaves the
// counts out and the stat cards say so themselves, so it raises no error toast.
export default function useLunarRunStats({
  enabled = true,
}: { enabled?: boolean } = {}): UseQueryResult<GetRunStatsResponse> {
  return useQuery({
    queryKey: [LUNAR_RUN_STATS_QUERY_KEY],
    queryFn: fetchLunarRunStats,
    enabled,
    meta: { silenceErrors: true },
  });
}
